module.exports = __webpack_public_path__ + "img/20200619_160901.f16649e8.jpg";